export default "__VITE_ASSET__BZ2hTrKa__"